import { render } from "./TraineeEditDrawer.vue?vue&type=template&id=49951276&ts=true"
import script from "./TraineeEditDrawer.vue?vue&type=script&lang=ts"
export * from "./TraineeEditDrawer.vue?vue&type=script&lang=ts"

import "./TraineeEditDrawer.vue?vue&type=style&index=0&id=49951276&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__